/**
 * JSON Schema for the device object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/Device",
  type: "object",
  properties: {
    modelName: { type: "string" },
    osVersion: { type: "string" },
    userAgent: { type: "string" },
    modelYear: { type: "string" }
  }
};
